import { isRateLimitError } from '../types/guards';
import { checkRateLimit } from '../utils';

import { widgetApi } from '../../config';

interface HasMaxUserPhoneResult {
  hasMaxUserPhone: boolean;
}

export const getHasMaxUserPhone = async (token: string | null) => {
  try {
    const result = await fetch(`${widgetApi}/author/hasMaxUserPhone`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    await checkRateLimit(result);

    if (!result.ok) {
      return { hasMaxUserPhone: false } as HasMaxUserPhoneResult;
    }

    return (await result.json()) as HasMaxUserPhoneResult;
  } catch (error: unknown) {
    // eslint-disable-next-line no-console
    console.error(error);
    // Пробрасываем rate limit ошибку дальше
    if (isRateLimitError(error)) {
      throw error;
    }
    return { hasMaxUserPhone: false } as HasMaxUserPhoneResult;
  }
};
